import { useQuery } from '@tanstack/react-query';
import * as Api from '@ViewModels';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

interface GetTagCategoriesParams {
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
	expandTags?: boolean;
	categoryId?: string;
}

export function useGetTagCategoryQuery({
	enabled = true,
	impersonationContext,
	expandTags = false,
	categoryId,
}: GetTagCategoriesParams) {
	const userSession = useUserSession();

	return useQuery({
		enabled: enabled && !!categoryId,
		queryKey: ['tagcategory/<categoryId>', categoryId, impersonationContext, expandTags],
		queryFn: async () => {
			return userSession.webServiceHelper.callAsync<Api.ITagCategory>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `tagcategory/${categoryId}`,
					queryParams: {
						expand: expandTags ? 'Tags' : null,
					},
				}),
				'GET'
			);
		},
	});
}

export function invalidateTagCategoryQuery({ categoryId }: { categoryId: string }) {
	return reactQueryClient.invalidateQueries({ queryKey: ['tagcategory/<categoryId>', categoryId] });
}

export function invalidateAllTagCategoryQueries() {
	return reactQueryClient.invalidateQueries({ queryKey: ['tagcategory/<categoryId>'] });
}
